// extracted by mini-css-extract-plugin
export default {"tabHeader":"TimeSlotTabHeader-rebranding-module__tabHeader___29Xgg","tabItem":"TimeSlotTabHeader-rebranding-module__tabItem___2X4Qz"};